import React, { useState, useRef, useEffect, useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import Flex from '../../../Flex';
import TextRenderer from '../../../TextRenderer';
import CommentViewer from '../../../DaEditorWrapper/Viewer/Comment';
import UserAvatar from '../../../User/Avatar';
import UserLink from '../../../User/Link';
import { BiDataHook } from '../../../biLogger';
import CommentFooter from '../CommentFooter';
import { CommentContext } from '../CommentContext';
import ActionsMenu from '../ActionsMenu';
import Timestamp from '../../../Timestamp';
import SpamCommentBody from '../SpamCommentBody';
import HiddenCommentBody from '../HiddenCommentBody';
import EditingCommentContent from './EditingCommentContent';
import CommentBadges from '../CommentBadges';
import { isActionable } from '../../utils';
import { MobileContext } from '../../../Context/MobileContext';
import s from './CommentContent.scss';
var CommentContent = function (_a) {
    var currentUser = _a.currentUser, className = _a.className, canPostComment = _a.canPostComment, compact = _a.compact, onReplyPosted = _a.onReplyPosted, replyClassName = _a.replyClassName, actionItemClassName = _a.actionItemClassName, onCommentUpdated = _a.onCommentUpdated, highlightOnMount = _a.highlightOnMount;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _b = useContext(CommentContext), comment = _b.comment, isEditing = _b.isEditing, isPeeking = _b.isPeeking, setActionMenuOpen = _b.setActionMenuOpen;
    var isMounted = useRef(false);
    var _c = useState(highlightOnMount), isHighlighted = _c[0], setIsHighlighted = _c[1];
    useEffect(function () {
        if (highlightOnMount && !isMounted.current) {
            var timeout = window.setTimeout(function () { return setIsHighlighted(false); });
            return window.clearTimeout(timeout);
        }
        isMounted.current = true;
    }, [highlightOnMount]);
    var isSpam = comment.isSpam, isHidden = comment.isHidden, isDeleted = comment.isDeleted, isAdminHidden = comment.isAdminHidden, isFeatured = comment.isFeatured, replies = comment.replies, user = comment.user, textContent = comment.textContent, commentId = comment.commentId;
    var isVisible = !isAdminHidden && !isDeleted;
    var isEdited = !!comment.edited;
    var timestamp = isEdited ? comment.edited : comment.posted;
    var showEditedPrefix = isEdited && !isMobile;
    var hideActionMenu = function () {
        setActionMenuOpen(false);
    };
    if (isEditing) {
        return (React.createElement(EditingCommentContent, { currentUser: currentUser, canPostComment: canPostComment, compact: compact, className: className, onCommentUpdated: onCommentUpdated }));
    }
    if (!isPeeking && isSpam && replies !== 0) {
        return React.createElement(SpamCommentBody, null);
    }
    if (!isPeeking && (isHidden || !isVisible) && replies !== 0) {
        return React.createElement(HiddenCommentBody, { className: className });
    }
    if ((isHidden || !isVisible || isSpam) && !isPeeking) {
        return null;
    }
    return (React.createElement(Flex, { className: classnames(s['core-badges'], className) },
        user && (React.createElement(UserAvatar, { user: user, size: 32, className: s['avatar'], withTooltip: false })),
        React.createElement("div", { className: s['main-block'] },
            React.createElement("div", { className: classnames(s['body-block'], isFeatured && s['body-block-featured'], isActionable(comment) && s['is-actionable'], isHighlighted && s['highlight']), onMouseLeave: hideActionMenu },
                React.createElement(Flex, { alignItems: "baseline", className: s['author-block'] },
                    user && (React.createElement(UserLink, { user: user, className: s['userlink'], withTooltip: true })),
                    React.createElement("a", { href: Url.commentLink(comment.typeId, comment.itemId, comment.commentId), className: s['timestamp'] },
                        showEditedPrefix && t('comment.info.edited') + " ",
                        React.createElement(Timestamp, { timestamp: timestamp, showTooltip: true, isCapitalized: !showEditedPrefix })),
                    isFeatured && !isMobile && (React.createElement("span", { className: s['featured'] }, t('comment.visibility.featuredV2')))),
                isFeatured && isMobile && (React.createElement("div", { className: s['featured'] }, t('comment.visibility.featuredV2'))),
                !!textContent && (React.createElement("div", { "data-hook": BiDataHook.COMMENT_BODY },
                    React.createElement(TextRenderer, { className: s['renderer'], textContent: textContent, reactViewer: CommentViewer, legacyTheme: 'comments', viewerKey: commentId }))),
                React.createElement(ActionsMenu, { className: s['actions-menu'], itemClassName: actionItemClassName }),
                comment.awardedBadges && (React.createElement(CommentBadges, { className: s['badge-list'] }))),
            React.createElement(CommentFooter, { onReplyPosted: onReplyPosted, canPostComment: canPostComment, replyClassName: replyClassName }))));
};
export default CommentContent;
//# sourceMappingURL=CommentContent.core_badges.js.map